import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import convertDataAttributes from '@widgets/shared/convertDataAttributes';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { childFormSchema, loginFormSchema, } from '@widgets/LoginForm/validation/schema';
import { useMemo } from 'preact/compat';
import { useCallback, useState } from 'react';
import FormNotices from '@widgets/shared/components/FormNotices';
import ParentForm from '@widgets/LoginForm/components/ParentForm';
import ChildrenForm from '@widgets/LoginForm/components/ChildrenForm';
import { Wrapper } from '@widgets/LoginForm/styles';
import useGlobalEvent from 'beautiful-react-hooks/useGlobalEvent';
function Form(props) {
    const [errorMessage, setErrorMessage] = useState(undefined);
    const [loginChildren, setLoginChildren] = useState([]);
    const { action, successUrl: theSuccessUrl, loginTitle, registerLink, registerCopy, loginHeadingSize, onHandleForgotPassword, forgotPasswordLink, childrenTitle, childrenCopy, } = props;
    const [successUrl, setSuccessUrl] = useState(theSuccessUrl);
    const [useLocalSuccessUrl, setUseLocalSuccessUrl] = useState(false);
    const [loginAction, setLoginAction] = useState(undefined);
    const onSuccessUrlChanged = useGlobalEvent('login.successUrl');
    const onSuccessUrlReset = useGlobalEvent('login.resetSuccessUrl');
    const onLoginActionChanged = useGlobalEvent('login.action');
    onSuccessUrlChanged((event) => {
        const params = event.detail;
        const currentPage = new URL(window.location.href);
        currentPage.search = params.toString();
        console.log('Setting success URL to: ', currentPage.toString());
        setSuccessUrl(currentPage.toString());
        setUseLocalSuccessUrl(true);
    });
    onSuccessUrlReset((e) => {
        console.log('Resetting success URL');
        setErrorMessage(theSuccessUrl);
        setUseLocalSuccessUrl(false);
    });
    onLoginActionChanged((e) => {
        const event = e;
        setLoginAction(() => event.detail);
    });
    const form = useForm({
        mode: 'onChange',
        resolver: yupResolver(loginFormSchema),
        defaultValues: {
            email: '',
        },
    });
    const childForm = useForm({
        mode: 'onChange',
        resolver: yupResolver(childFormSchema),
    });
    const { getValues: parentGetValues } = form;
    const handleNoticeClose = useCallback(() => {
        setErrorMessage(undefined);
    }, []);
    let formElement;
    // main account has not yet logged in.
    if (loginChildren.length !== 0) {
        // we have logged in and there are child accounts associated.
        formElement = (_jsx(FormProvider, { ...childForm, children: _jsx(ChildrenForm, { loginChildren: loginChildren, successUrl: successUrl, useLocalSuccessUrl: useLocalSuccessUrl, childrenTitle: childrenTitle, childrenCopy: childrenCopy, onHandleError: (message) => {
                    setErrorMessage(message);
                }, password: parentGetValues('password'), username: parentGetValues('email'), childrenHeadingSize: loginHeadingSize, loginAction: loginAction }) }));
    }
    else {
        formElement = (_jsx(FormProvider, { ...form, children: _jsx(ParentForm, { successUrl: successUrl, useLocalSuccessUrl: useLocalSuccessUrl, loginTitle: loginTitle, registerLink: registerLink, registerCopy: registerCopy, loginHeadingSize: loginHeadingSize, onHandleForgotPassword: onHandleForgotPassword, forgotPasswordLink: forgotPasswordLink, onHandleChildren: (theLoginChildren) => {
                    setLoginChildren(theLoginChildren);
                    if (theLoginChildren.length > 0) {
                        setErrorMessage(undefined);
                    }
                }, onHandleError: (message) => {
                    setErrorMessage(message);
                }, loginAction: loginAction }) }));
    }
    return (_jsxs(Wrapper, { children: [errorMessage && (_jsx("div", { style: { marginBottom: '1rem' }, children: _jsx(FormNotices, { message: errorMessage, type: "error", handleClose: handleNoticeClose }) })), formElement] }));
}
export default function LoginForm(props) {
    const { dataset, onHandleForgotPassword } = props;
    const formConfig = convertDataAttributes(dataset ?? {});
    const formConfigOptions = useMemo(() => ({
        ...formConfig,
        onHandleForgotPassword,
    }), [onHandleForgotPassword, formConfig]);
    return (_jsx(Form, { ...formConfigOptions }));
}
LoginForm.defaults = {
    onHandleForgotPassword: undefined,
    onSuccessNoRedirect: undefined,
};
